import styled from 'styled-components';

// Reusable page header for centered titles across the app
export const PageHeaderStyled = styled.h1`
  width: 100%;
  text-align: center;
  font-size: 1.6rem;
  margin: 0.8rem 0;
  color: ${({ theme }) => (theme === 'dark' || theme?.name === 'dark') ? '#fff' : '#000'};
  font-weight: 700;
`;

export default PageHeaderStyled;
